import _ from 'lodash';
import { get, post, put, del, } from 'utils/fetch';
import { 
  createAction,
  entity_reducer,
  list_reducer,
  list_remove } from 'utils/store';
import { RequestState } from 'constants/constants';
import { listReducer, createList, createListSelector } from 'utils/list';

import { REMOVE_CHANNEL } from 'store/models/Channel';
import { FETCH_CHANNEL_STREAM_STATS, FETCH_CAMPAIGN_STREAM_STATS } from 'store/models/Stats';
import { selectCurrentAccountId } from 'store/models/Account';



// ======================
// ACTIONS
// ====================== 
export const FETCH_STREAM = 'FETCH_STREAM';
export const FETCH_STREAMS_CHANNEL = 'FETCH_STREAMS_CHANNEL';
export const FETCH_LIVE_STREAMS = 'FETCH_LIVE_STREAMS';
export const FETCH_RECENT_STREAMS = 'FETCH_RECENT_STREAMS';

// ======================
// SELECTORS
// ====================== 
export const selectStreams = state => state.models.streams;
export const selectStream = (state, streamId) => state.models.streams[streamId];
export const selectStreamsByServiceId = (state, ids) => _.filter(state.models.streams, s => _.includes(_.castArray(ids), s.serviceId)  );
export const selectStreamThumbs = (state, streamId) => state.models.liveThumbUrls[streamId];

export const selectStreamsForChannel = createListSelector('streamsForChannel');
export const selectStreamsForCampaign = createListSelector('streamsForCampaign');
export const selectRecentStreams = createListSelector('recentStreams');

export const isStreamLive = s => !_.isNil(s) && !_.isEmpty(s.start) && _.isEmpty(s.end);
export const peakViewers = s => !_.isNil(s) && s.stats && s.stats.peakViewers;
export const avgViewers = s => !_.isNil(s) && s.stats && s.stats.avgViewers;

const Stream = {
  actions: {

    fetchStreamDetails: (streamId) => dispatch => get({
      url: `/api/stream/:streamId/details`,
      params: { streamId },
      dispatch, 
      action: FETCH_STREAM,
    }),

    fetchStreamsByChannel: (channelId, from, to) => dispatch => get({
      url: `/api/stream/channel/:channelId`,
      params: { channelId, from, to },
      dispatch, 
      action: FETCH_STREAMS_CHANNEL,
    }),

    fetchLiveStreams: accountId => (dispatch, getState) => 
      accountId ?? selectCurrentAccountId(getState())
        |> get({
            url: `/api/account/:accountId/livestreams`,
            params: { accountId: # },
            dispatch,
            action: FETCH_LIVE_STREAMS,
    }),

    fetchRecentStreams: (count = 20, channelId) => (dispatch, getState) => 
      selectCurrentAccountId(getState())
        |> get({
            url: `/api/account/:accountId/recent_streams`,
            params: { accountId: #, count, channelId },
            dispatch,
            action: FETCH_RECENT_STREAMS,
    }),
  },
  spec: { 
    streams: {},
    liveThumbUrls: {},
  },

  reducer: (state, type, body, action, json) => {
    if(action.result !== RequestState.SUCCESS)
      return state;

    if(type === FETCH_STREAM) {
      state = { ...state, liveThumbUrls: {
        ...state.liveThumbUrls,
        [action.params.streamId]: body.liveThumbUrls,
      }}
    }    
    
    if(body && body.streams) {
      return { ...state, streams: entity_reducer(state.streams, body.streams, '_id')};
    }

    switch(type) {
      case REMOVE_CHANNEL:
          return { ...state, streams: _.filter(state.streams, { channelId: body._id }) };
    }
    return state;
  },

  listSpec: {
    streamsForChannel: {},
    streamsForCampaign: {},
  },


  listReducer: (state, type, body, action, json) => {
    if(action.url && action.result !== RequestState.SUCCESS)
      return state;

    switch(type) {
      case FETCH_STREAMS_CHANNEL:
      case FETCH_CHANNEL_STREAM_STATS:
        return { 
          ...state,
          streamsForChannel: {
            ...state.streamsForChannel,
            [action.params.channelId]: createList(body.streams, 'streams', '_id')
          } 
        }
      case FETCH_CAMPAIGN_STREAM_STATS:
        return { 
          ...state,
          streamsForCampaign: {
            ...state.streamsForCampaign,
            [action.params.campaignId]: createList(body.streams, 'streams', '_id')
          } 
        }

      case FETCH_RECENT_STREAMS:
        return { 
          ...state,
          recentStreams: {
            ...createList(body.streams, 'streams', '_id')
          } 
        }
    }

    return state;
  },
}
export default Stream;
